export const isDevEnv = () => {
    return process.env.REACT_APP_FIREBASE_PROJECT_ID.includes("-dev");
}

export const isStgEnv = () => {
    return process.env.REACT_APP_FIREBASE_PROJECT_ID.includes("-stg");
}

export const isPrdEnv = () => {
    return !isDevEnv() && !isStgEnv();
}

